import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Menu from '../components/Menu'
import NotesMenu from '../components/NotesMenu'
import TopBarLayout from '../layouts/TopBarLayout'
import ui from "../stores/ui"
import { observer } from "mobx-react"

@observer
class ScreeningSessionLayout extends Component {
  render() {
    const { title, children, demo } = this.props

    return (
      <Fragment>
        <Menu icon="fas fa-bars">
          <Menu.Logo />
          <Menu.Divider />
          { !demo && <Menu.Divider /> }
          { !demo &&
            <Menu.Link
              dontCloseMenu={true}
              str="Should prompts be shown?"
              icon={ui.promptsHidden ? "fas fa-toggle-off" : "fas fa-toggle-on"}
              onClick={ui.togglePrompts}
            />
          }
          { !demo && !ui.promptsHidden &&
            <Menu.Link
              dontCloseMenu={true}
              str="Force all prompts to be open?"
              icon={ui.allPromptsOpen ? "fas fa-toggle-on" : "fas fa-toggle-off"}
              onClick={ui.toggleAllPromptsOpen}
            />
          }
          {!demo && <Menu.Divider />}
          <Menu.LanguageSwitcher />
          {/* {!demo && <Menu.QuitLink to={`/edit-patient/${patientID}`} str="titles.endSession" icon="fas fa-chevron-left" />} */}
          {demo && <Menu.QuitLink to="/" str="titles.endSession" icon="fas fa-chevron-left" />}
        </Menu>
        <NotesMenu />
        <TopBarLayout title={title}>
          {children}
        </TopBarLayout>
      </Fragment>
    )
  }
}

export default withRouter(ScreeningSessionLayout)



// WEBPACK FOOTER //
// ./src/layouts/ScreeningSessionLayout.js